import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { SetStateAction, useContext, useEffect, useRef, useState } from "react";
import { CloudDownload, EyeIcon, Mail } from "lucide-react";
import axios from "axios";
import toast from "react-hot-toast";

import GetAppIcon from "@mui/icons-material/GetApp";
import {
  CancellationReasonTypes,
  ExampaperdetailTypes,
  ExamsDetailsTypes,
  IExamResultTypeWrapper,
  UserDetailsForResult,
} from "../../interfaces/exams.interface";
import { TransitionProps } from "@mui/material/transitions";
import CustomAccordion from "../common/CustomAccordion";

import GeneralTabs from "../common/GeneralTabs";

import { useNavigate } from "react-router-dom";
import { baseServiceUrl, urls } from "../../environment";
import PaperWiseMarksDistribution from "./PaperWiseMarksDistribution";
import AnswerSectionForScrtiny from "./scrutiny/AnswerSectionForScrtiny";
import {
  capitalize,
  decryptAES256CBC2,
  encryptWithFixedKey,
  generateRandomBytes,
} from "../../utils";

import ExamCancellationNotification from "../../components/ExamCancellation";
import useUserStore from "../../stores/useUserStores";
import useExamStores from "../../stores/useExamStores";
import useExamServices from "../../context/useExamServices";
import LoadingAnimation from "../../components/LoadingAnimation";


const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
interface ResultQAReportProps {
  handleClose: () => void;
  examsDetailsTypes?: ExamsDetailsTypes | null;
  refreshList?: () => void;
  cancellationDetails: CancellationReasonTypes[];
  setCancellationDeatails: React.Dispatch<
    React.SetStateAction<CancellationReasonTypes[]>
  >;
  onlyAnswerKeys?: boolean;
  setOnlyAnswerKeys?: React.Dispatch<SetStateAction<boolean>>;
}

const ResultQAReport = ({
  handleClose,
  examsDetailsTypes,
  refreshList,
  cancellationDetails,
  setCancellationDeatails,
  onlyAnswerKeys,
  setOnlyAnswerKeys,
}: ResultQAReportProps) => {
  const Navigate = useNavigate();

  console.log("examsDetailsTypes >>>  ", examsDetailsTypes);

  const {
    userdetail,
    setLoading,
    token,
    fullscreenmode,
    setFullScreenMode,
    setExam,
    exam,
    setExamStarted,
    examStarted,
    examQuestionDetails,
    setExamQuestionDetails,
    setStartExamMessage,
    loading,
    startExamMessage,
    resumeDuration,
    setResumeDuration,
  } = useUserStore();
  const examContext = useExamStores();
  const examService = useExamServices();
  const mountRef = useRef<boolean>(false);
  const [pageLoader, setPageLoader] = useState<boolean>(false);

  // const appLevelContext = useAppLevelContext();
  // const examContext = useExamsContext();
  const [selectedPaper, setSelectedPaper] = useState<number>(-1);
  const [openBasicPortal, setOpenBasicPortal] = useState<boolean>(true);

  // const userContext = useUserContext();
  const [userResult, setUserResult] = useState<IExamResultTypeWrapper | null>(
    null
  );
  const [selectedPaperDetails, setSelectedPaperDetails] =
    useState<ExampaperdetailTypes | null>(null);

  useEffect(() => {
    if (examsDetailsTypes) {
      // setLoading(true);
      setPageLoader(true);
      (async () => {
        try {
          const encryption_key = generateRandomBytes();

          let rawPayload = {
            exam_id: examsDetailsTypes.id,
            user_id: userdetail.id,
            encryption_key,
          };

          console.log("rawPayload >>>>>>>>>>>> ", rawPayload);
          const payload = encryptWithFixedKey(rawPayload);
          const response = await axios.post(
            baseServiceUrl + urls.examineeResult,
            payload,
            {
              headers: {
                Authorization: "Bearer " + token,
              },
            }
          );
          if (response?.data && response?.data?.response) {
            const rawResponse = await decryptAES256CBC2(
              response.data?.response,
              btoa(encryption_key)
            );
            const responsedData = JSON.parse(rawResponse);
            console.log("responsedData:   134", responsedData);
            if (responsedData) {
              setUserResult(responsedData);
            }
          }
          // if (response.data && response.data.exam_paper_details) {
          //   if (Array.isArray(response.data.exam_paper_details))
          //     setUserResult(
          //       response.data.exam_paper_details.sort(
          //         (selfA: any, selfB: any) => selfA.exam_id - selfB.exam_id
          //       )
          //     );
          //   else setUserResult(response.data.exam_paper_details);
          //   if (response.data.exam_paper_details.length > 0) {
          //     setSelectedPaper(response.data.exam_paper_details[0].exam_id);
          //     setSelectedPaperDetails(response.data.exam_paper_details[0]);
          //   }
          // }
        } catch (err: any) {
          toast.error(
            err?.response?.data?.message || "Error encounter. Please try again."
          );
        } finally {
          setPageLoader(false);
          // setLoading(false);
        }
      })();
    }
  }, [examsDetailsTypes]);

  const FileDownload = require("js-file-download");
  const download = () => {
    if (!examsDetailsTypes) return toast.error("Exam not selected");
    const file_name: any =
      "Result_" +
      userdetail.id +
      "_" +
      new Date().toLocaleDateString("en-GB") +
      ".pdf";
    let payload: any = {
      exam_id: examsDetailsTypes?.exam_group,
      user_id: userdetail.id,
    };
    setLoading(true);
    axios({
      url: `${baseServiceUrl}${urls.examViewPDF}`,
      method: "POST",
      responseType: "blob", // Important
      headers: {
        Authorization: "Bearer " + token,
      },

      data: payload,
    })
      .then((response) => {
        if (response.status == 200) {
          FileDownload(response.data, file_name);
          toast.success("Result Downloaded Successfully");
        }
      })
      .catch(async (error) => {
        toast.error("Something went wrong");
        // ApiCallErrorAction(error?.response?.data?.Errors);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   if (selectedPaper > 0) {
  //     const _selectedResult = userResult.find(
  //       (self) => self.exam_id === Number(selectedPaper)
  //     );
  //     if (_selectedResult) setSelectedPaperDetails(_selectedResult);
  //   }
  // }, [selectedPaper]);

  const getCancelledExamDetails = (payload: any) => {
    examService.getCancelledExamHandler({
      payload,
      successCallback: (data: any) => {
        if (data && data?.resp) setCancellationDeatails(data?.resp);
      },
      errorCallback: () => {
        toast.error("Something went wrong");
      },
    });
  };

  useEffect(() => {
    if (!examsDetailsTypes || !examsDetailsTypes?.exam_group) {
      setCancellationDeatails([]);

      setUserResult(null);
      setOnlyAnswerKeys?.(true);
    }
  }, [examsDetailsTypes]);

  return (
    <Dialog
      fullWidth
      fullScreen
      open={!!examsDetailsTypes && !!examsDetailsTypes?.exam_group}
      onClose={handleClose}
      TransitionComponent={Transition}
      className="p-0"
    >
      <ExamCancellationNotification
        onClose={() => setCancellationDeatails([])}
        cancellationDetails={
          cancellationDetails?.length > 0 ? cancellationDetails[0] : undefined
        }
      />
      <div className="py-2 w-full bg-blue-500 flex items-center justify-between  md:px-8 ">
        <p className="text-white text-sm px-2 lg:text-2xl font-semibold ">
          Answer Information of{" "}
          {userResult && userResult?.exam_paper_details?.[0]?.title
            ? capitalize(userResult?.exam_paper_details?.[0]?.title)
            : ""}
        </p>
        <IconButton
          onClick={handleClose}
          className="text-white"
          aria-label="delete"
        >
          <CloseIcon className="text-white" />
        </IconButton>
      </div>
      <DialogContent className="!px-2 lg:px-4">
        <div className="">
          <div className=" w-full mx-auto flex  justify-between">
            {!!examsDetailsTypes && userdetail ? (
              <div className="w-[100%]">
                <CustomAccordion
                  title={"Basic Information"}
                  isExpanded={openBasicPortal}
                  setExpanded={setOpenBasicPortal}
                  secondary
                  // highlightColor={"bg-[#c026d3]"}
                >
                  <div className="p-3 grid grid-cols-12 gap-y-2">
                    <div className="col-span-12 md:col-span-7 ">
                      <div className="text-xs lg:text-sm font-semibold ">
                        Exam Name{" "}
                      </div>
                      <div className=" font-semibold text-xl">
                        {examsDetailsTypes?.exam_group_title}
                      </div>
                    </div>
                    <div className="col-span-12 lg:col-span-5">
                      <div className=" text-xs lg:text-sm font-semibold ">
                        Candidate Name{" "}
                      </div>
                      <div className=" font-semibold text-xl">
                        {userdetail.fullName}
                      </div>
                    </div>
                    <div className="col-span-12 lg:col-span-7">
                      <div className=" font-semibold text-sm ">
                        Candidate Email
                      </div>
                      <div className="font-semibold text-sm lg:text-xl ">
                        {userdetail.email}
                      </div>
                    </div>
                    {selectedPaperDetails &&
                    selectedPaperDetails?.is_exam_cancelled ? (
                      <div className="col-span-12 lg:col-span-5 ">
                        <div className=" font-semibold text-sm ">
                          Exam Status
                        </div>
                        <div className="font-semibold text-xl text-red-500 ">
                          Cancelled
                        </div>
                      </div>
                    ) : (
                      <div className="col-span-12 lg:col-span-5">
                        <div className=" font-semibold text-sm ">
                          Candidate Phone.
                        </div>
                        <div className="font-semibold text-xl ">
                          {userdetail.phone}
                        </div>
                      </div>
                    )}
                  </div>
                </CustomAccordion>
              </div>
            ) : (
              <></>
            )}
          </div>

          {/* fdfdd */}
          {userResult ? (
            <AnswerSectionForScrtiny
              userResult={userResult}
              selectedPaper={selectedPaper}
              setSelectedPaper={setSelectedPaper}
              selectedPaperDetails={selectedPaperDetails}
              examsDetailsTypes={examsDetailsTypes}
              handleClose={handleClose}
              refreshList={refreshList}
              onlyAnswerKeys={onlyAnswerKeys}
            />
          ) : (
            <>
              {selectedPaperDetails?.is_exam_cancelled ? (
                <>
                  <div className="w-full py-2">
                    <div className="w-full bg-red-50 py-2 px-5 flex items-center justify-between mt-8   border-l-4 border-red-500">
                      <h1 className="text-red-500 text-sm">
                        View Exam Cancellation Reason
                      </h1>
                      <IconButton
                        className="cursor-pointer"
                        onClick={() =>
                          getCancelledExamDetails({
                            userId: userdetail.user_id,
                            examId: selectedPaperDetails?.exam_id,
                            searchString: "",
                            pageIndex: null,
                            pageSize: null,
                          })
                        }
                      >
                        <EyeIcon className="text-red-500" />
                      </IconButton>
                    </div>
                  </div>
                </>
              ) : !pageLoader ? (
                <p className="text-xl text-center">No Data Found</p>
              ) : pageLoader ? (
                <LoadingAnimation message="Fetching data please wait ...." />
              ) : (
                <></>
              )}
            </>
          )}

          {/* <div className="w-[95%] mx-6 my-6">
            {userResult.map((item) => (
              <div
                key={item.qid}
                className={`mb-4 p-4 border rounded-lg transition-transform transform hover:scale-105 ${
                  item.marks < 0
                    ? "hover:bg-red-100 bg-white"
                    : "hover:bg-green-100 bg-white"
                }`}
              >
                <p className="font-semibold">{item.question}</p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "2px",
                  }}
                >
                  <p>
                    <span className="font-medium">Alloted Marks: </span>
                    {item.alloted_marks}
                  </p>
                  <p>
                    <span className="font-medium ml-5">Negative Marks: </span>
                    {item.negetive_mark}
                  </p>
                </div>
  
                <p className="mt-1">
                  <span className="font-medium">Selected Answer: </span>
                  {item.selected_options_value} {item.selected_answer}
                </p>
                <p className="mt-1">
                  <span className="font-medium">Correct Answer: </span>
                  {item.correct_answer_option}
                  {item.correct_answer}
                </p>
                <p
                  className={`mt-1 font-medium ${
                    item.marks < 0 ? "text-red-500" : "text-green-500"
                  }`}
                >
                  Marks: {item.marks}
                </p>
              </div>
            ))}
          </div> */}
        </div>
        <div className=" py-2  w-full">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex items-center justify-center gap-x-4">
              <Mail className="text-slate-800 mt-[3px]" size={21} />
              <p className="text-slate-800 text-lg">
                For any queries or support, please contact the Help Desk at:
                <a
                  href="mailto:jsace2025@gmail.com"
                  target="_blank"
                  className="text-blue-400 hover:text-blue-300 ml-2 font-medium transition-colors duration-200 hover:underline"
                >
                  jsace2025@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </DialogContent>
      {/* </> */}
    </Dialog>
  );
};

export default ResultQAReport;
